'use strict';

angular.module('shop').controller('PaymentController', function ($rootScope, $scope, $state, $stateParams, $window, CustomerService, ShopService, PaymentService, LogService) {

	$scope.loading = true;

	CustomerService.get().then(function (customer) {
		$scope.cart = ShopService.getCart();
        
		$scope.customer = customer;
		$scope.cart.customerID = customer.id;

		ShopService.getSummary($scope.cart).then(function(summary) {
	
			if (!summary.summaryArticles || summary.summaryArticles.length === 0) {
				$state.go('checkout');
				return;
			}

			// If total price of order is 0 we skip Klarna checkout
			var totalPrice = summary.payMethodPrice + summary.missingPrice;
			if (totalPrice == 0) {
				$state.go('confirmation');
			}

			var orderId = $stateParams['order_id'];
			if (orderId && orderId !== '') {
				LogService.log($scope.customer.id, 'shop-checkout', 'Det gick inte att slutföra köp hos klarna för order-id: ' + self.klarnaOrderId);
			} else {
				LogService.log($scope.customer.id, 'shop-checkout', 'Ny order med Klarna checkout.');
			}
	
			PaymentService.getCheckout(customer.id, $scope.cart).then(function(checkoutData) {
				$scope.checkoutHtml = checkoutData['html_snippet'];
	
				var checkoutContainer = document.getElementById('my-checkout-container');
				checkoutContainer.innerHTML = $scope.checkoutHtml;
				var scriptsTags = checkoutContainer.getElementsByTagName('script');
				// This is necessary otherwise the scripts tags are not going to be evaluated
				for (var i = 0; i < scriptsTags.length; i++) {
					var parentNode = scriptsTags[i].parentNode;
					var newScriptTag = document.createElement('script');
					newScriptTag.type = 'text/javascript';
					newScriptTag.text = scriptsTags[i].text;
					parentNode.removeChild(scriptsTags[i]);
					parentNode.appendChild(newScriptTag);
				}
	
				$scope.loading = false;
			}, function() {
				LogService.log($scope.customer.id, 'shop-checkout', 'Det gick inte att initiera Klarna checkout för ny order.');
			});
			
		});
	}, function() {
		$state.go('checkout');
	});

});
